import React, { useState, useEffect,useRef } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link,useNavigate } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { FaLongArrowAltRight } from "react-icons/fa";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import mixitup from 'mixitup';
import { GetPublicationsList } from "../../api/publications-functions";
import { GetPublicationDistinctYearList } from "../../api/publication-distinct-year-functions";
import globalVariables from "../../global-variables";
import Metatag from "../../hooks/Metatag";

export default function Publications() {
  const [toggler, setToggler] = useState(true);
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();


  }, []);

    const [publication, setPublicationList] = useState(null);
    const [publicationyear, setPublicationYearList] = useState([]);
    

     // success function when the list is retrived
     const OnGetPublicationSuccess = (p_response) => {
    
        // set the list for looping
        setPublicationList(p_response);
    }
    const OnGetPublicationYearSuccess = (p_response) => {
        // set the list for looping
        setPublicationYearList(p_response);

            let _objPublication = new Object();
            _objPublication.pub_status = 1;
  
            // call the function to get the publication
            GetPublicationsList(_objPublication, OnGetPublicationSuccess, navigate); 

    }
    // things to be done when the page is loaded
        useEffect(() => {

        //make the object for getting the news type year list
        let _objPublicationYear = new Object();
        _objPublicationYear.pub_status = 1;

        // call the function to get the news type year list
        GetPublicationDistinctYearList(_objPublicationYear, OnGetPublicationYearSuccess, navigate)

    }, []);


    useEffect(()=>{

      var containerEl = document.querySelector('.container-mix');

      var mixer = mixitup(containerEl);
      
      // Cleanup when the component is unmounted
    return () => {
      mixer.destroy();
    };

    },[publication])
    
  return (
    <>
      <Header main_className="bg-header"></Header>

      {/* Metatag  */}
      <Metatag title='Publications by NDMC IIT-B Team'
                        keywords='Publications by NDMC IIT-B Team, Journals by NDMC IIT-B Team, Books by NDMC IIT-B Team' 
                        description='Publications, Journals, Books written and published by NDMC IIT-B Team'
                        />
      <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-publications.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
        <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
        <div className="masthead d-flex align-items-center w-100">
          <Container className="px-4 px-md-5">
            <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">Publications</h1>
          </Container>
        </div>
      </Container>

    
      <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">

        <div className="controls mb-lg-5 mb-4 d-md-block" >
            <a className="filter mixitup-control-active" data-filter="all" >All</a>
          {
            publicationyear?.map((val_year)=>{
              return(
                    <a className="filter " data-filter={`.year-${val_year.pub_year}`}  >{val_year.pub_year}</a>
              )
            })
          }
        </div>

        <Row className="row-cols-1 row-cols-lg-3 g-lg-4 gy-4 container-mix">
          {
            publication?.map((val_pub)=>{
              return(

                  <Col className={`mix year-${val_pub.pub_year} `}>
                    <div className="bg-white p-4 rounded-3 h-100">
                      <span dangerouslySetInnerHTML={{ __html : val_pub.pub_authers}}></span>
                    </div>
                  </Col>
              )
            })
          }

          <Col className="grid-sizer"></Col>
        </Row>

      </Container>

      {/* Breadcrumb */}
      <Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto">
        <Breadcrumb>
          <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Publications</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      {/* Breadcrumb */}
    </>
  );
}